<template>
  <v-card outlined :loading="loading">
    <v-card-text class="d-flex flex-wrap justify-space-around px-">
      <div class="text-center px-4">
        <h6 class="mt-2 mb-0">
          {{
            (reducedPayments.tickets - (reducedPayments.courtesy || 0)) | number
          }}
        </h6>
        <span class="text-caption">Ingressos Vendidos</span>
      </div>
      <div class="text-center px-4">
        <h6 class="mt-2 mb-0">
          {{ (reducedPayments.courtesy || 0) | number }}
        </h6>
        <span class="text-caption">Cortesias </span>
      </div>
      <div class="text-center px-4">
        <h6 class="mt-2 mb-0">{{ reducedPayments.tickets | number }}</h6>
        <span class="text-caption">Ingressos Emitidos</span>
      </div>
      <div class="text-center px-4">
        <h6 class="mt-2 mb-0">
          {{
            ((reducedPayments.amount - reducedPayments.fee) /
              reducedPayments.tickets)
              | currency
          }}
        </h6>
        <span class="text-caption">Ticket Médio</span>
      </div>
      <div class="text-center px-4">
        <h6 class="mt-2 mb-0">
          {{ (reducedPayments.amount - reducedPayments.fee) | currency }}
        </h6>
        <span class="text-caption">Valor Líquido</span>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    payments: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    reducedPayments() {
      return this.payments.reduce(
        (acc, payment) => {
          if (payment.status !== "succeeded") return acc;

          for (const ticket of payment.Ticket) {
            acc.tickets += 1;
            acc.amount += ticket.amount;
            acc.fee += ticket.platformFee;
            if (payment.paymentType === "COURTESY") acc.courtesy += 1;
          }

          return acc;
        },
        {
          tickets: 0,
          courtesy: 0,
          amount: 0,
          fee: 0,
        }
      );
    },
  },
};
</script>
